/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './template.pug';
import defaultIcon from './icon.pug';
import {
  IAlertLevel, IAlertModel,
} from '../types';

const alertCssClasses: Record<IAlertLevel, string> = {
  Error: 'alert-danger',
  Warning: 'alert-warning',
  Confirmation: 'alert-success',
  Info: 'alert-info',
};

export default class AlertView extends DeterministicView {
  get attributes() {
    return {
      role: 'listitem',
    };
  }

  get tagName() {
    return 'li';
  }

  get events() {
    return {
      'click .alert__action': () => (this.getState() as IAlertModel).action!.callback(),
      'click .alert-ignore': () => {
        this.trigger('ignore');
        this.remove();
      },
    };
  }

  remove() {
    this.$el.slideUp();
    super.remove();
  }

  get template() {
    return ({ model: state }: { model: object }): string => {
      const model = state as IAlertModel;
      const {
        level = 'Confirmation',
        hasIcon = false,
        customCssClass,
        icon = defaultIcon,
        dismissible = level !== 'Error',
        message,
        action,
      } = model;
      const cssClass = customCssClass || alertCssClasses[level];

      return template({
        cssClass,
        level,
        hasIcon,
        icon: _.isFunction(icon) ? (icon as (alert: IAlertModel) => string)(model) : icon,
        dismissible,
        message,
        action,
      });
    };
  }
}
